import { render, staticRenderFns } from "./FillAfterSaleInfo.vue?vue&type=template&id=72faf7a2&scoped=true&"
import script from "./FillAfterSaleInfo.vue?vue&type=script&lang=js&"
export * from "./FillAfterSaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./FillAfterSaleInfo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FillAfterSaleInfo.vue?vue&type=style&index=1&id=72faf7a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72faf7a2",
  null
  
)

export default component.exports